import { required } from 'vuelidate/lib/validators'
import {
  slugAsyncValidator,
  slugValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import blogPostsSlugsQuery from '@/services/gql/types/BlogPosts/queries/blogPostsSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, blogPostsSlugsQuery, ctx, 'blogPosts')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    blogCategoryId: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    slug: (() => {
      if (isNew) {
        return false
      }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })()
  }
}
